function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Heading, Label } from '../../atoms';
import { Tag } from '../Tag';
import ReactConfigContext from '../../ReactConfigContext';
export default function SmallImageCard(param) {
    var _param_direction = param.direction, direction = _param_direction === void 0 ? 'vertical' : _param_direction, _param_variant = param.variant, variant = _param_variant === void 0 ? 'default' : _param_variant, tag = param.tag, image = param.image, label = param.label, title = param.title, description = param.description, action = param.action, className = param.className;
    var _image_sizes;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, LinkComponent = _useContext_config.LinkComponent, ImageComponent = _useContext_config.ImageComponent;
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge('isolate relative rounded-xl transition-all outline-subtle-700 outline outline-0 hover:shadow-xl hover:shadow-subtle-700 hover:outline-1', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('absolute z-10', direction === 'vertical' && 'top-6 left-6', direction === 'horizontal' && 'top-6 right-6')
    }, !!tag && /*#__PURE__*/ React.createElement(Tag, tag, tag.label)), /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        draggable: false,
        className: twMerge('grid', direction === 'vertical' && 'grid-cols-1 grid-rows-[16rem_1fr]', direction === 'horizontal' && 'grid-cols-1 grid-rows-[16rem_1fr] md:grid-rows-1 md:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_38rem]')
    }), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('grid grid-cols-1 grid-rows-1 overflow-hidden safari-fix-transform', variant === 'ghost' && twMerge('rounded-xl', direction === 'horizontal' && 'md:order-last'), variant === 'default' && twMerge(direction === 'vertical' && 'rounded-t-xl', direction === 'horizontal' && 'rounded-tl-xl rounded-tr-xl md:order-last md:rounded-tl-none md:rounded-br-xl'))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        sizes: (_image_sizes = image.sizes) !== null && _image_sizes !== void 0 ? _image_sizes : '(min-width: 48em) 800px, 100vw',
        className: twMerge(image.className, 'w-full h-full object-cover object-center')
    })))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === 'default' && 'p-7 bg-subtle-500', variant === 'ghost' && 'pt-5', variant !== 'ghost' && twMerge(direction === 'vertical' && 'rounded-b-xl', direction === 'horizontal' && 'rounded-bl-xl rounded-br-xl md:rounded-br-none md:rounded-tl-xl'))
    }, !!label && /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === 'default' && 'mb-5', variant === 'ghost' && 'mb-3')
    }, /*#__PURE__*/ React.createElement(Label, {
        className: "text-tag-bg-base"
    }, label)), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-3 grid-cols-1 grid-flow-row auto-rows-max"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: direction === 'horizontal' ? 'h3' : 'h4'
    }, title), !!description && /*#__PURE__*/ React.createElement(Body, {
        className: "prose prose-neutral"
    }, description)))));
}

//# sourceMappingURL=SmallImageCard.js.map